module.exports = __webpack_public_path__ + "img/20200106160538672.5735295a.jpg";